import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  CircularProgress,
  Box
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { React, useState, useEffect } from "react";
import Alert from "../../components/ui/Alert";
import { sizes } from "./dashboardUtils";
import { useDispatch, useSelector } from "react-redux";
import { getApprovalStats, getScenarios, setState } from "./dashBoardSlice";
import PendingActions from "./PendingActions";
import RunningPeriodStatus from "./RunningPeriodStatus";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

const orderStatusList = ["All", "Normal", "Blocked", "Blocked and Reviewed"];

export default function SearchForm() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.dashboard);
  const {
    drawerOpen,
    selectedCountry,
    selectedCountryID,
    countries,
    selectedCriticality,
    selectedCriticalityID,
    selectedOrderStatus,
    scenario,
    scenarioCriticalityList,
    scenarios,
    isLoading
  } = state;

	const loginState = useSelector((store) => store.login);
	const { globalSelectedCountryName,globalSelectedCountryID,} = loginState 
  
	useEffect(() => {
		if(globalSelectedCountryName !==null && globalSelectedCountryName !== "" ){
		  dispatch(setState("selectedCountry", globalSelectedCountryName));
		  dispatch(setState("selectedCountryID", globalSelectedCountryID));
      setValidate({
        ...validate,
        countryValidated: true,
      });      
		}
	},[globalSelectedCountryID]);  

  const [validate, setValidate] = useState({
    countryValidated: false,
    criticalityValidated: false,
    orderStatusValidated: false,
  });

  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });

  const displayAlert = (showAlert, alertMessage) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: `${showAlert}`,
      alertMessage: `${alertMessage}`,
    });
  };

  useEffect(() => {
    if(globalSelectedCountryName ==null || globalSelectedCountryName == "" || globalSelectedCountryName ==undefined ){
    dispatch(setState("selectedCountry", ""));
    dispatch(setState("selectedCountryID", ""));
    }
    dispatch(setState("selectedCriticality", ""));
    dispatch(setState("selectedCriticalityID", ""));
    dispatch(setState("selectedOrderStatus", ""));
    dispatch(setState("scenario", ""));
  }, []);

  useEffect(() => {
    //Check if any of the dropdown are false and then set alertDisplay to false
    const isAnyKeyValueFalse = (o) => !!Object.keys(o).find((k) => !o[k]);

    if (isAnyKeyValueFalse(validate)) {
      setAlert({ ...Alert, alertDisplay: false });
    }
  }, [validate]);

  function setCountry(event) {
    const name = event.target.value;

    if (name) {
      setValidate({
        ...validate,
        countryValidated: true,
      });
    }

    const countryID = countries.find(
      (country) => country.countryName === name
    ).countryID;

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  }

  function setCriticality(event) {
    const name = event.target.value;
    let criticalityID = 0;
    if (name == "All") criticalityID = 0;
    else
      criticalityID = scenarioCriticalityList.find(
        (criticality) => criticality.scenarioCriticalityDesc === name
      ).scenarioCriticalityID;

    if (name) {
      setValidate({
        ...validate,
        criticalityValidated: true,
      });
    }

    dispatch(setState("selectedCriticality", name));
    dispatch(setState("selectedCriticalityID", criticalityID));
  }

  function setOrderStatus(event) {
    const status = event.target.value;

    if (status) {
      setValidate({
        ...validate,
        orderStatusValidated: true,
      });
    }

    dispatch(setState("selectedOrderStatus", status));
  }

  function setScenario(event) {
    const scenario = event.target.value;
    dispatch(setState("scenario", scenario));
  }

  async function handleSearch() {
    if (!validate.countryValidated)
      displayAlert(true, "Please select a Country");
    else if (!validate.criticalityValidated)
      displayAlert(true, "Please select a Criticality");
    else if (!validate.orderStatusValidated)
      displayAlert(true, "Please select a Order Status");
    else {
      const getScenarioParams = {
        countryID: selectedCountryID,
        status: selectedOrderStatus,
        scenario: scenario,
        criticalityId: selectedCriticalityID,
      };

      const getApprovalStatsParams = {
        countryID: selectedCountryID,
      };

      dispatch(setState("scenarios",[]));
      dispatch(setState("isLoading",true));

      try{
      await dispatch(getScenarios(getScenarioParams));
      //dispatch(setState("isLoading", false));
      await dispatch(getApprovalStats(getApprovalStatsParams));

      }
      catch{
        console.error("Error fetching the data");
      }
      finally{
        dispatch(setState("isLoading", false));
      }
    }
  }

  return (
    <>
    <Typography variant="subtitle1" sx={{ mt: 2, mb: 2 }}>
    Search for scenario
  </Typography>
  <Grid
    container
    columns={12}
    spacing={2}
    sx={{ justifyContent: "space-between",alignItems:"center" }}
  >
    <Grid item sm={3} md={2.5} lg={2.5}>
      <FormControl fullWidth>
        <InputLabel>Country</InputLabel>
        <Select
          value={selectedCountry}
          label="Country"
          sx={{
            height: selectHeight,
            width: "100%",
            color: "black.main",
            mt: 1,
          }}
          MenuProps={{
            disableScrollLock:true,
          }}
          onChange={setCountry}
        >
          {countries.map((country, index) => {
            return (
              <MenuItem key={index} value={country.countryName}>
                {country.countryName}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Grid>

    <Grid item sm={3} md={2.5} lg={2.5}>
      <FormControl fullWidth>
        <InputLabel>Order Status</InputLabel>
        <Select
          value={selectedOrderStatus}
          label="Order Status"
          sx={{
            height: selectHeight,
            width: "100%",
            color: "black.main",
            mt: 1,
          }}
          MenuProps={{
            disableScrollLock:true,
          }}
          onChange={setOrderStatus}
        >
          {orderStatusList.map((status, index) => {
            return (
              <MenuItem key={index} value={status}>
                {status}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Grid>

    <Grid item sm={3} md={2.5} lg={2.5}>
      <FormControl fullWidth>
        <InputLabel>Scenario Criticality</InputLabel>
        <Select
          value={selectedCriticality}
          label="Scenario Criticality"
          sx={{
            height: selectHeight,
            width: "100%",
            color: "black.main",
            mt: 1,
          }}
          MenuProps={{
            disableScrollLock:true,
          }}
          onChange={setCriticality}
        >
          <MenuItem key={0} value="All">
            All
          </MenuItem>
          {scenarioCriticalityList.map((criticality, index) => {
            return (
              <MenuItem
                key={criticality.scenarioCriticalityID}
                value={criticality.scenarioCriticalityDesc}
              >
                {criticality.scenarioCriticalityDesc}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Grid>

    <Grid item sm={2.5} md={3.5} lg={3.5}>
          <TextField
           sx={{
            width:"100%",
          }}           
          id="outlined-basic"
          label="Scenario"
          variant="outlined"
          size="small"
          value={scenario}
          onChange={setScenario}
          autoComplete="dashboard-scenario-name"
          InputProps={{ autoComplete: "dashboard-scenario-name" }}
          name="dashboard-scenario-name"
          />
    </Grid>

    <Grid item sm={1} md={1} lg={1} sx={{ml:-1}}>
      <Button
        // startIcon={<ManageSearchIcon />}
        sx={{
          height: "40px",
          width:"120px",
          bgcolor: "darkred.light",
          color: "white.main",
          textTransform: "none",
          fontWeight: "bold",
          mt: 0,
          "&:hover": {
             bgcolor: "darkred.main",
             color: "white.main",
          },
       }}
        onClick={handleSearch}
      >
        Search
      </Button>
    </Grid>
  </Grid>
  {alert.alertDisplay && (
    <Alert message={alert.alertMessage} severity={alert.alertSeverity} />
  )}
    <Paper
      elevation={2}
      sx={{
        width: drawerOpen ? "75%" : "100%",
        p: 2,
        borderRadius: 2,
        mt: 3,
        minHeight: "300px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position:"relative"
      }}
    >
    {isLoading && (
       <Box sx={{position:"absolute",top:"50%",left:"50%",transform :"translate(-50%,-50%"}}> 
          <CircularProgress /> 
       </Box>
     )}
      <Grid container columns={12} sx={{ justifyContent: "space-between" }}>
        <Grid sm={8.8} item>
          <RunningPeriodStatus />
        </Grid>
        <Grid sm={3} item>
          <PendingActions selectedCountryID={selectedCountryID} />
        </Grid>
      </Grid>
    </Paper>
    </>
  );
}
